import { Box, Typography } from '@mui/material';
import { MusicNote } from '@mui/icons-material';
import { useState } from 'react';

export default function PodcastCoverArt({
  imageUrl,
  alt = 'Podcast cover art',
  size = 200,
  variant = 'square', // 'square' or 'rounded'
  loading = 'lazy',
  sx = {}
}) {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const borderRadius = variant === 'rounded' ? 2 : 1;

  // Show fallback if no image or image failed to load
  if (!imageUrl || imageError) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          bgcolor: 'primary.main',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius,
          color: 'white',
          boxShadow: 2,
          ...sx
        }}
      >
        <MusicNote sx={{ fontSize: size * 0.4, opacity: 0.9 }} />
        <Typography
          variant="caption"
          sx={{
            mt: 1,
            fontSize: size * 0.06,
            opacity: 0.8,
            textAlign: 'center',
            px: 1
          }}
        >
          Podcast
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={imageUrl}
      alt={alt}
      onError={handleImageError}
      loading={loading}
      decoding="async"
      sx={{
        width: size,
        height: size,
        objectFit: 'cover',
        borderRadius,
        boxShadow: 2,
        display: 'block',
        ...sx
      }}
    />
  );
}
